var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _path4, _path5, _path6, _rect5, _rect6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerTriplo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 180,
    viewBox: "0 0 430 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 0.5,
    width: 125,
    height: 179,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 0.5,
    width: 125,
    height: 179,
    rx: 9.5,
    stroke: "#767D8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.25 56.25H52.75C48.6079 56.25 45.25 59.6079 45.25 63.75V116.25C45.25 120.392 48.6079 123.75 52.75 123.75H105.25C109.392 123.75 112.75 120.392 112.75 116.25V63.75C112.75 59.6079 109.392 56.25 105.25 56.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.875 82.5C68.9816 82.5 71.5 79.9816 71.5 76.875C71.5 73.7684 68.9816 71.25 65.875 71.25C62.7684 71.25 60.25 73.7684 60.25 76.875C60.25 79.9816 62.7684 82.5 65.875 82.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.75 101.25L94 82.5L52.75 123.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 152.5,
    y: 0.5,
    width: 125,
    height: 179,
    rx: 9.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 152.5,
    y: 0.5,
    width: 125,
    height: 179,
    rx: 9.5,
    stroke: "#767D8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M241.25 56.25H188.75C184.608 56.25 181.25 59.6079 181.25 63.75V116.25C181.25 120.392 184.608 123.75 188.75 123.75H241.25C245.392 123.75 248.75 120.392 248.75 116.25V63.75C248.75 59.6079 245.392 56.25 241.25 56.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.875 82.5C204.982 82.5 207.5 79.9816 207.5 76.875C207.5 73.7684 204.982 71.25 201.875 71.25C198.768 71.25 196.25 73.7684 196.25 76.875C196.25 79.9816 198.768 82.5 201.875 82.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.75 101.25L230 82.5L188.75 123.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 288.5,
    y: 0.5,
    width: 125,
    height: 179,
    rx: 9.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 288.5,
    y: 0.5,
    width: 125,
    height: 179,
    rx: 9.5,
    stroke: "#767D8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M377.25 56.25H324.75C320.608 56.25 317.25 59.6079 317.25 63.75V116.25C317.25 120.392 320.608 123.75 324.75 123.75H377.25C381.392 123.75 384.75 120.392 384.75 116.25V63.75C384.75 59.6079 381.392 56.25 377.25 56.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.875 82.5C340.982 82.5 343.5 79.9816 343.5 76.875C343.5 73.7684 340.982 71.25 337.875 71.25C334.768 71.25 332.25 73.7684 332.25 76.875C332.25 79.9816 334.768 82.5 337.875 82.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M384.75 101.25L366 82.5L324.75 123.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerTriplo);
export default __webpack_public_path__ + "static/media/bannerTriplo.487a9440b1103601c905bdb7431ee002.svg";
export { ForwardRef as ReactComponent };